import Vue from 'vue'
import helpers from './../helpers'

const mutations = {
  setVideo(state, video) {
    Object.assign(state, video)
    //Fix when new object on video is undefined
    state.adaptive = video.adaptive ? video.adaptive : {}
    state.subtitles = video.subtitles ? video.subtitles : []
  },
  receiveVideoScenes(state, data) {
    state.scenes = data.scenes
  },
  receiveTracking(state, data) {
    console.log('receiveTracking', data)
    if (data.type === 'Started') {
      Object.assign(state.tracking, { isPending: true, pendingJobId: data.id })
    } else if (data.type === 'Done') {
      Object.assign(state.tracking, { isPending: false, pendingJobId: null })
    } else {
      console.log('receiveTracking Once', data)
      state.tracking.trackedObjects[data.ref] = data
    }
  },
  createNew(state, data) {
    console.log(data)
    if (data.url.indexOf('//') < 0) {
      data.url = '/videos/' + data.url
    }
    console.log(data)
    Object.assign(state, initializeState(data))
  }
}
const getters = {
  getScenes: state => state.scenes,
  tags: state => state.tags
}
const actions = {
  createTag(context) {
    let tag = _createNewTag()
    context.commit('addTag', tag)
    return tag
  },
  createScene(context, waypoints) {
    const selectedTag = context.rootState.selection.tag
    if (!selectedTag) {
      actions.createTag(context)
    }
    const scene = _createNewScene(waypoints)
    context.commit('addScene', scene)
    return scene
  },
  startTracker(context, {trackFromWaypoint, trackToWaypoint}) {
    const wp = trackFromWaypoint
    const time = wp.time
    const timeTo = trackToWaypoint ? trackToWaypoint.time : time + 10
    const trackingObject = helpers.createTrackingObjectFromWaypoint(wp, time, timeTo)
    Object.assign(context.state.tracking, {isPending: true, trackingObject})
    console.log('startTracker', context, trackingObject)
    // Vue.Remote.emit('TrackObject', trackingObject)
  }
}

export default {
  state: initializeState({}),
  mutations,
  actions,
  getters
}

function initializeState(data) {
  return {
    src: data.url,
    name: '',
    assetId: '',
    assetTitle: 'no asset title',
    analytics: data.analytics,
    meta: {
      title: data.title,
      linkNext: data.linkNext,
      theme: data.theme,
      showScrubbar: data.showScrubbar,
      showSubtitles: data.showSubtitles,
      languages: data.languages,
      defaultLanguage: data.defaultLanguage,
      isAutoplay: data.isAutoplay,
      isMuted: data.isMuted,
      poster: data.poster
    },
    adaptive: data.adaptive,
    subtitles: data.subtitles,
    tags: [],
    scenes: [],
    dimensions: {},
    tracking: {
      isPending: false,
      pendingJobId: null,
      trackingObject: {},
      trackedObjects: {}
    }
  }
}

/**
 * private helpers, move later
 */
function _createNewTag() {
  // just the tag, no default scene
  return _createTagObj()
}

function _createTagObj() {
  return {
    id: (new Date()).getTime().toString(36),
    name: 'New Tag',
    meta: {
      name: '',
      title: '',
      text: '',
      URL: '',
      colorScheme: {},
      behaviour: {}
    },
    scenes: []
  }
}

function _createNewScene(waypoints) {
  if (!waypoints) {
    waypoints = [/* _createWaypointObj(time) */]
  } else if (!Array.isArray(waypoints)) {
    waypoints = [waypoints]
  }
  const scene = _createSceneObj(waypoints)
  return scene
}

function _createSceneObj(waypoints) {
  return {
    name: '',
    waypoints: waypoints || []
  }
}
